<template>
  <uni-popup ref="prescrip" type="bottom">
    <uni-card title="处方" :is-full="true">
      <div class="gridClass">
        <div class="tips">
          <span>请您选择处方模板</span>
        </div>
        <div class="grid_wrap">
          <div
            v-for="(item, i) in prescripTypeList"
            :key="i"
            class="grid-item"
            @click="selectPre(item, i)"
          >
            <img
              v-if="i == selectedIndex"
              class="grid-icon"
              :src="require('@funcPuzzle/mini_doctor/' + item.selectImg + '.png')"
            />
            <img
              v-else
              class="grid-icon"
              :src="require('@funcPuzzle/mini_doctor/' + item.img + '.png')"
            />
            <span :class="i == selectedIndex ? 'select_grid_text' : 'grid_text'">
              {{ item.text }}
            </span>
          </div>
        </div>
      </div>
      <!-- <template v-slot:footer>
        <div class="footer-box">
          <span class="btn"> 确认 </span>
        </div>
      </template> -->
      <template v-slot:close>
        <uni-icons type="closeempty" color="#666" @click="close" />
      </template>
    </uni-card>
  </uni-popup>
</template>

<script>
import { mapState } from 'vuex'
import { getKeyValue } from '@/views/funcPuzzle/utils/util.js'
import { getBusinessDicList } from '@/views/funcPuzzle/utils/index.js'
export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    value: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapState('user', ['userInfos']),
    hospitalID() {
      return this.userInfos.hospitalID
    }
  },
  data() {
    return {
      /* eslint-disable no-sparse-arrays */
      prescripList: [
        {
          selectImg: 'western',
          img: 'westernDefault',
          text: '西药处方',
          code: '2'
        },
        {
          selectImg: 'chineseMedicine',
          img: 'chineseDefault',
          text: '中成药处方',
          code: '1'
        },
        {
          selectImg: 'mongolianMedicine',
          img: 'mongolianDefault',
          text: '蒙药处方',
          code: '4'
        },
        {
          selectImg: 'chineseHerbal',
          img: 'chineseHerbalDefault',
          text: '中草药处方',
          code: '3'
        },
        {
          selectImg: 'particle',
          img: 'particleDefault',
          text: '中药颗粒处方',
          code: '6'
        },
        {
          selectImg: 'mongolianMedicine',
          img: 'mongolianDefault',
          text: '中药小包装处方',
          code: '5'
        },
        ,
        {
          selectImg: 'chineseMedicine',
          img: 'chineseDefault',
          text: '蒙药处方',
          code: '8'
        },
        {
          selectImg: 'onePersonPre',
          img: 'onePersonDefault',
          text: '一人一方',
          code: '7'
        }
      ],
      selectedIndex: '0',
      drugTypeOption: [],
      prescripTypeList: []
    }
  },
  watch: {
    visible: {
      handler(val) {
        if (val) {
          this.$bus.emit('createNewPre')

          this.prescripTypeList = []
          this.drugTypeOption = []
          this.getBusinessConfig()

          this.$refs.prescrip.open()
        } else {
          // this.close()
        }
      },
      immediate: true
    },
    value(val) {
      if (val) {
        this.$refs.prescrip.open()
      } else {
        this.close()
      }
    }
  },
  methods: {
    getKeyValue,
    getDrugOption(type) {
      return this.getKeyValue('prescrip_type').filter(item => {
        return item.code === type
      })
    },
    getBusinessConfig() {
      getBusinessDicList({
        pageNum: 1,
        pageSize: 1,
        tableName: 'enabled_drug_template',
        code: this.hospitalID
      }).then(rs => {
        const data = JSON.parse(rs.DoctorServicePackageList[0].value)
        data.enabledDrugTemplate.sort((a, b) => {
          return a.order - b.order
        })
        data.enabledDrugTemplate.map(item => {
          const _item = this.getDrugOption(item.prescripType)
          this.drugTypeOption = this.drugTypeOption.concat(_item)
        })

        this.drugTypeOption.forEach(item => {
          this.prescripTypeList.push(
            this.prescripList.filter(item2 => {
              return item.code === item2.code
            })[0]
          )
        })
      })
    },
    selectPre(item, i) {
      this.selectedIndex = i
      this.close()
      this.$bus.emit('prescripType', item.code)
    },
    close() {
      if (!this.$refs.prescrip) {
        return false
      }
      this.$emit('update:visible', false)
      this.$refs.prescrip.close()
    },
    open() {
      this.$emit('update:visible', true)
      this.$refs.prescrip.open()
    }
  },
  mounted() {
    this.$bus.on('showSelectPre', () => {
      this.selectedIndex = '0'
      // this.$refs.prescrip.open()
      this.open()
    })
  },
  destroyed() {
    this.$bus.off('prescripType')
  }
}
</script>

<style lang="scss" scoped>
.gridClass {
  background-color: #fff;
  min-height: 11.306667rem;
  .grid_wrap {
    display: flex;
    flex-wrap: wrap;
    margin-top: 0.64rem;
  }
  .tips {
    width: 100%;
    text-align: center;
    font-size: 0.64rem;
    font-weight: 400;
    color: #222222;
    line-height: 0.896rem;
  }
  ::v-deep .uni-grid-item__box {
    display: flex;
    justify-content: center;
  }
  .grid-item {
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    flex-direction: column;
    width: 5.333333rem;
    margin-bottom: 1.109333rem;
    .grid-icon {
      width: 2.133333rem;
      height: 2.133333rem;
      margin-bottom: 0.341333rem;
    }
    .grid-text {
      font-size: 0.554667rem;
      color: #767676;
    }
    .select_grid_text {
      font-size: 0.554667rem;
      color: #0089ff;
    }
  }
}
.footer-box {
  text-align: center;
  width: 14.933333rem;
  height: 1.536rem;
  background: #2772ff;
  line-height: 1.536rem;
  border-radius: 0.213333rem;
  font-size: 0.554667rem;
  .btn {
    color: #fff;
  }
}
</style>
